module.exports = __webpack_public_path__ + "img/soft-devs.b632d8c7.svg";